<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <div class="vertical-flow vh-80">
                <!-- PESQUISA E FILTROS -->
                <div class="filters-bar mb-3">
                    <div class="filters-bar-form form-columns-fit">
                        <div class="columns">
                            <div class="column is-9">
                                <search-bar
                                    :clean="limparBusca"
                                    :tooltipLabel="$t('msg-campo-busca-n', {
                                            n: 'cliente',
                                        })"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    title="tipo"
                                    placeholder="selecione"
                                    :options="tipoList"
                                    :mlLabels="true"
                                    v-model="tipoSelected"
                                    @input="onTipoChange"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- LISTAGEM -->
                <div class="registry-wrapper">
                    <BloqueadoTable
                        ref="bloqueadoTable"
                        :saldos="saldos"
                        :saldoTotal="contaFlex.saldoTotalBloqueado"
                        :isMobile="isMobile"
                        :sortTable="sortTable"
                        :isEmpty="isEmpty"
                        :isLoading="isLoading"
                        @updateCheckeds="updateCheckeds"
                        @showModalFlexGerenciaSaldoManage="
                            () => {
                                showModalFlexGerenciaSaldoManage = true;
                            }
                        "
                    />
                </div>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        <lateral-content
            v-model="showModalFlexGerenciaSaldoManage"
            confirmClose
        >
            <FlexGerenciaSaldoManage
                compact
                class="pt-4"
                v-if="showModalFlexGerenciaSaldoManage"
                :contaFlex="contaFlex"
                :saldosSelecionados="saldosSelecionados"
                @saved="handleSaldoBloqueadoUpdate"
                @voltar="showModalFlexGerenciaSaldoManage = false"
            />
        </lateral-content>
    </div>
</template>

<script>
import FlexLancamentoService from "@/services/vendas/financeiro/FlexLancamentoService.js";
import ContainerLoader from "@/components/content/loader/ContainerLoader.vue";
import BloqueadoTable from "@/components/vendas/financeiro/flex/abas/BloqueadoTable.vue";
import FlexGerenciaSaldoManage from "@/components/vendas/financeiro/flex/modal/FlexGerenciaSaldoManage.vue";
import MotivoService from "@/services/agro/MotivoService.js";
import VerifiedDatePicker from "@/components/shared/form/VerifiedDatePicker.vue";

export default {
    name: "Bloqueado",

    components: {
        ContainerLoader,
        VerifiedDatePicker,
        BloqueadoTable,
        FlexGerenciaSaldoManage,
    },
    props: {
        contaFlex: {
            type: Object,
            default: (_) => null,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                "VEN_FLEX_LIBERA_SALDO_LOG"
            ),
            service: new FlexLancamentoService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            isLoading: false,
            isEmpty: false,
            permissao: {},
            showModalFlexGerenciaSaldoManage: false,
            accessDenied: false,
            saldos: [],
            saldosSelecionados: [],
            debouncedOnSearch: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            limparBusca: false,
            tipoList: [
                { label: "todos", id: 2 },
                { label: "credito", id: 1 },
                { label: "debito", id: 0 },
            ],
            tipoSelected: { label: "todos", id: 2 },
            filters: {
                queryFilter: "",
                column: "dataHora",
                order: "desc",
                situacao: 1,
                currentPage: 1,
                perPage: 10,
                tipo: 2,
                idVenFlex: 0,
            },
        };
    },
    created() {
        this.filters.idVenFlex = this.$route.params.id;
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "flex"
        );

        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        handleSaldoBloqueadoUpdate() {
            this.carregarDados();

            this.saldosSelecionados = [];

            this.$refs.bloqueadoTable.clearSaldosSelecionados();

            this.showModalFlexGerenciaSaldoManage = false;
            this.$emit("updateContaFlex");
        },
        updateCheckeds(newSaldosSelecionados) {
            this.saldosSelecionados = newSaldosSelecionados;
        },
        carregarDados() {
            this.isLoading = true;

            this.filters.tipo = this.tipoSelected.id;

            this.service
                .findAllBloqueados(this.filters)
                .then(({ content, totalElements }) => {
                    this.saldos = content;

                    this.isEmpty = this.saldos.length < 1

                    this.pagination.totalRows = totalElements;
                })
                .catch((error) => {
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        onTipoChange(val) {
            this.tipoSelected = val
                ? this.tipoList.find((tipo) => tipo.id === val.id)
                : this.situacoes[0];

            this.carregarDados();
        },
        isMobile() {
            return window.innerWidth <= 760;
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        resetPagination() {
            this.pagination.perPage =
                this.pagination.perPageOptions[this.pagination.optionStarted];
            this.pagination.resetPagination = true;
            this.pagination.currentPage = 1;

            this.filters.currentPage = 1;
            this.filters.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

            this.carregarDados(1);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;

            this.filters.perPage = value.perPage;
            this.filters.currentPage = value.currentPage;

            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filters.queryFilter = this.removeToSearch(value);
            this.carregarDados(1);
        },
    },
};
</script>

<style lang="scss" scoped>
.vh-80 {
    min-height: 80vh;
}

.size {
    width: 100px;
}
.h-max-content {
    height: max-content;
}
.g-2 {
    gap: 8px;
}
.card-content {
    .content {
        font-weight: bold;
        text-align: center;
        font-size: 3vw;
    }
}
.green {
    color: #7cb342;
}
.orange {
    color: #ffb300;
}
#main {
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
